import { MRT_ColumnDef, MRT_PaginationState } from "material-react-table";
import { useState } from "react";
import { Box, Button, Chip, IconButton, Typography } from "@mui/material";
import { Delete, Edit, RemoveRedEye } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { DataTable } from "../../libs/core/components/data-table";
import { useGetBlogsQuery, useDeleteBlogMutation } from "./api/blogsApi";
import { Blog } from "./types/blog";
import { ConfirmModal } from "../../libs/ui/modal/confirm_modal";
import AddEditBlog from "./components/AddEditBlogs";

const BlogManager: React.FC = () => {
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState<Blog | null>(null);
  const navigate = useNavigate();

  const { data: blogs, isLoading, isError, isFetching } = useGetBlogsQuery();
  const [deleteBlog] = useDeleteBlogMutation();

  const columns: Array<MRT_ColumnDef<Blog>> = [
    
    {
      header: "Image",
      accessorKey: "image",
      size: 80,
      Cell({ row: { original } }) {
        return (
          <img
            src={`${original.image}`}
            alt="Blog"
            width={60}
            height={60}
            style={{ borderRadius: 6 }}
          />
        );
      },
    },
    {
      header: "Title",
      accessorKey: "title",
      size: 150,
    },
    {
        header: "Slug",
        accessorKey: "slug",
        size: 100,
      },
    {
      header: "Views",
      id: "views",
      size: 100,
      Cell() {
        return (
          <Typography variant="body2" color="text.secondary">
            No views
          </Typography>
        );
      },
    },
    // {
    //   header: "Content",
    //   accessorKey: "content",
    //   size: 300,
    //   Cell({ row: { original } }) {
    //     const createMarkup = (html:any) => {
    //       return { __html: html };
    //     };
        
    //     const truncated = original.content.length > 100
    //       ? original.content.slice(0, 100) + '...'
    //       : original.content;
    
    //     return (
    //       <div 
    //         dangerouslySetInnerHTML={createMarkup(truncated)}
    //         style={{
    //           overflow: 'hidden',
    //           textOverflow: 'ellipsis',
    //           display: '-webkit-box',
    //           WebkitLineClamp: 3, // Limit to 3 lines
    //           WebkitBoxOrient: 'vertical'
    //         }}
    //       />
    //     );
    //   },
    // },

   
  ];

  return (
    <Box>
      <DataTable<Blog>
        toolbar={
          <Box display="flex" alignItems="center" width="100%">
            <Box display="flex" gap={3} alignItems="center" flex="1">
              <Typography variant="h6">Blogs</Typography>
              <Chip
                color="primary"
                variant="outlined"
                label={`${blogs?.data?.length ?? 0} Blogs`}
              />
            </Box>
            <Button
              onClick={() => {
                setSelectedBlog(null);
                setOpenDialog(true);
              }}
              sx={{ minWidth: "200px" }}
              variant="contained"
            >
              Add New Blog
            </Button>
          </Box>
        }
        list={blogs?.data ?? []}
        count={blogs?.data?.length ?? 0}
        columns={columns}
        getRowId={(row) => row?.id?.toString()}
        isLoading={isLoading}
        isSuccess={!isError}
        isError={isError}
        isFetching={isFetching}
        renderRowActions={(row) => (
          <Box display={"flex"} gap={1}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setSelectedBlog(row);
                setOpenConfirmModal(true);
              }}
            >
              <Delete />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setSelectedBlog(row);
                setOpenDialog(true);
              }}
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/blogs/${row.id}`);
              }}
            >
              <RemoveRedEye />
            </IconButton>
          </Box>
        )}
        pagination={pagination}
        onPaginationChange={setPagination}
        onRowClick={(row) => navigate(`/blogs/${row.id}`)}
      />

      <AddEditBlog
        open={openDialog}
        blog={selectedBlog}
        setModalOpen={setOpenDialog}
      />

      {selectedBlog && (
        <ConfirmModal
          type="warning"
          title="Delete Blog"
          message={`Are you sure you want to delete '${selectedBlog.title}'?`}
          modalOpen={openConfirmModal}
          setModalOpen={setOpenConfirmModal}
          onOk={() => {
            deleteBlog(selectedBlog.id.toString());
            setOpenConfirmModal(false);
            setSelectedBlog(null);
          }}
        />
      )}
    </Box>
  );
};

export default BlogManager;
